<script setup lang="ts">
import { computed } from 'vue';

const props = withDefaults(
  defineProps<{
    width?: number;
    height?: number;
    viewBox?: string;
  }>(),
  {
    viewBox: '0 0 218 160',
    width: 218,
    height: 160,
  }
);

const originalWidth = 218;
const originalHeight = 160;
const aspectRatio = originalWidth / originalHeight;

const computedWidth = computed(() => {
  if (props.width) return props.width;
  if (props.height) return props.height * aspectRatio;
  return originalWidth;
});

const computedHeight = computed(() => {
  if (props.height) return props.height;
  if (props.width) return props.width / aspectRatio;
  return originalHeight;
});
</script>

<template>
  <svg
    :width="computedWidth"
    :height="computedHeight"
    :viewBox="viewBox"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g filter="url(#filter0_d_5879_131700)">
      <path
        d="M124.779 47.7618L106.743 71.0856C106.176 71.9354 105.043 72.0299 104.193 71.3689L81.7195 53.7108C80.8697 53.1442 80.7752 52.0111 81.4362 51.1612L104.854 21.4163C105.421 20.5664 106.554 20.472 107.404 21.133L123.74 33.9753L124.779 47.7618Z"
        fill="#5C6479"
      />
    </g>
    <path
      d="M117.13 36.5248L106.271 28.0262C106.082 27.8374 105.987 27.5541 106.176 27.1764C106.365 26.9875 106.648 26.8931 107.026 27.0819L117.885 35.5805C118.074 35.7694 118.169 36.0526 117.98 36.4304C117.696 36.7136 117.413 36.7136 117.13 36.5248Z"
      fill="#2E3746"
    />
    <path
      d="M108.443 33.8809L104.382 30.5759C104.194 30.387 104.099 30.1038 104.288 29.7261C104.477 29.4428 104.76 29.4428 105.138 29.6316L109.198 32.9366C109.387 33.1255 109.482 33.4088 109.293 33.7865C109.009 34.0698 108.632 34.0698 108.443 33.8809Z"
      fill="#2E3746"
    />
    <path
      d="M123.74 33.9756L118.735 40.3023C117.98 41.2466 118.263 42.5686 119.113 43.2296L124.873 47.7621"
      fill="#2E3746"
    />
    <path
      d="M117.791 49.1786L112.125 44.8349L106.271 40.2079L100.888 35.9587C100.322 35.4865 99.3774 35.5809 98.9053 36.2419L91.1622 46.0625C90.69 46.6291 90.7845 47.5733 91.351 48.0455L108.348 61.4543C108.915 61.9265 109.859 61.832 110.331 61.171L118.074 51.3505C118.546 50.5006 118.452 49.7452 117.791 49.1786ZM99.8496 49.0842L101.549 46.8179L106.743 50.8783L105.043 53.1446L99.8496 49.0842ZM104.571 53.8056L102.966 55.883L97.7721 51.8226L99.3774 49.7452L104.571 53.8056ZM109.009 48.0455L107.309 50.3118L102.116 46.2514L103.816 43.9851L109.009 48.0455ZM104.288 43.3241L106.176 41.0578L111.37 45.1182L109.67 47.3845L104.288 43.3241ZM113.731 55.3165L107.97 50.7839L109.67 48.5176L115.43 53.0502L113.731 55.3165ZM101.455 45.6848L95.8836 41.3411L97.5833 39.0748L103.155 43.4185L101.455 45.6848ZM95.317 42.0021L100.888 46.3458L99.1886 48.6121L93.6173 44.2684L95.317 42.0021ZM107.498 51.4449L113.258 55.9775L111.559 58.2437L105.799 53.7112L107.498 51.4449ZM117.413 50.6895L115.997 52.4836L110.237 47.9511L111.936 45.6848L117.224 49.8396C117.602 50.0285 117.602 50.4062 117.413 50.6895ZM100.322 36.4308L105.421 40.4912L103.721 42.7575L98.1499 38.4138L99.5663 36.6197C99.7551 36.3364 100.133 36.3364 100.322 36.4308ZM91.8232 46.4402L93.0507 44.9294L98.622 49.2731L97.0167 51.3505L91.8232 47.2901C91.6343 47.1012 91.6343 46.6291 91.8232 46.4402ZM108.915 60.51L103.627 56.3552L105.232 54.2778L110.992 58.8103L109.67 60.4156C109.481 60.7933 109.104 60.7933 108.915 60.51Z"
      fill="#2E3746"
    />
    <path
      d="M168.732 62.6626H67.0268C64.9352 62.6626 63.105 64.4934 63.105 66.5857V132.232C63.105 134.324 64.9352 133.539 67.0268 133.539H168.471C170.563 133.539 172.393 134.324 172.393 132.232V66.5857C172.654 64.4934 170.824 62.6626 168.732 62.6626Z"
      fill="#262A31"
    />
    <path
      d="M165.314 66.4775H70.6644C68.7179 66.4775 67.0146 68.1165 67.0146 69.9896V128.759C67.0146 130.632 68.7179 129.929 70.6644 129.929H165.071C167.018 129.929 168.721 130.632 168.721 128.759V69.9896C168.964 68.1165 167.261 66.4775 165.314 66.4775Z"
      fill="#474E61"
    />
    <path
      d="M187.818 129.878V131.97C187.818 134.324 185.727 136.416 183.374 136.416H52.3851C50.0321 136.416 47.9404 134.324 47.9404 131.97V129.878H187.818Z"
      fill="#353B4A"
    />
    <path
      d="M130.037 129.878V130.663C130.037 131.97 128.991 133.278 127.423 133.278H108.075C106.768 133.278 105.46 132.232 105.46 130.663V129.878H130.037Z"
      fill="#262A31"
    />
    <path
      d="M128.207 96.9244H119.579V88.2937C119.579 87.2475 118.795 86.4629 117.749 86.4629C116.703 86.4629 115.919 87.2475 115.919 88.2937V96.9244H107.291C106.245 96.9244 105.46 97.709 105.46 98.7552C105.46 99.8013 106.245 100.586 107.291 100.586H115.919V109.217C115.919 110.263 116.703 111.047 117.749 111.047C118.795 111.047 119.579 110.263 119.579 109.217V100.586H128.207C129.253 100.586 130.037 99.8013 130.037 98.7552C130.037 97.709 129.253 96.9244 128.207 96.9244Z"
      fill="#8E96AB"
    />
    <g filter="url(#filter1_d_5879_131700)">
      <path
        d="M187.564 96.0155L158.64 111.673C156.968 112.568 154.894 111.963 153.98 110.287L139.032 82.5921C138.138 80.9185 138.744 78.8417 140.418 77.9269L169.342 62.2695C171.013 61.3741 173.088 61.9794 174.001 63.6551L188.968 91.3525C189.862 93.0261 189.236 95.1201 187.564 96.0155Z"
        fill="url(#paint0_linear_5879_131700)"
      />
    </g>
    <path
      d="M183.725 92.7348L158.294 106.5C157.582 106.893 156.689 106.616 156.297 105.903L143.938 83.0022C143.546 82.2896 143.823 81.3959 144.535 81.0032L169.966 67.2379C170.678 66.8452 171.571 67.1219 171.963 67.8345L184.321 90.7357C184.713 91.4484 184.437 92.3421 183.725 92.7348Z"
      fill="#5B6379"
    />
    <path
      d="M166.839 90.6732L157.554 95.696L159.345 87.9285L166.839 90.6732Z"
      fill="#474E61"
    />
    <path
      d="M174.515 86.5133L161.15 93.7562L163.735 82.5755L174.515 86.5133Z"
      fill="#2E3746"
    />
    <path
      d="M156.007 86.8474C157.1 86.9694 158.085 86.181 158.208 85.0864C158.33 83.9918 157.542 83.0056 156.449 82.8836C155.356 82.7615 154.37 83.5499 154.248 84.6445C154.126 85.7391 154.913 86.7254 156.007 86.8474Z"
      fill="#474E61"
    />
    <g filter="url(#filter2_d_5879_131700)">
      <path
        d="M190.734 101.979L157.85 102.629C155.954 102.658 154.388 101.169 154.345 99.2609L153.762 67.7947C153.735 65.8975 155.225 64.3295 157.132 64.2842L190.015 63.6338C191.912 63.6049 193.478 65.094 193.521 67.002L194.12 98.479C194.147 100.376 192.63 101.95 190.734 101.979Z"
        fill="url(#paint1_linear_5879_131700)"
      />
    </g>
    <path
      d="M188.827 97.302L159.915 97.8726C159.102 97.8951 158.436 97.2398 158.414 96.4268L157.933 70.4082C157.912 69.5951 158.567 68.9278 159.38 68.9053L188.292 68.3347C189.105 68.3122 189.771 68.9674 189.793 69.7805L190.273 95.7991C190.295 96.6121 189.639 97.2795 188.827 97.302Z"
      fill="#5B6379"
    />
    <path
      d="M174.767 87.7271L164.212 87.9327L169.365 81.8511L174.767 87.7271Z"
      fill="#354156"
    />
    <path
      d="M183.495 87.5503L168.297 87.858L175.721 79.1072L183.495 87.5503Z"
      fill="#2E3746"
    />
    <path
      d="M166.894 79.3598C167.81 79.9696 169.047 79.7209 169.658 78.8042C170.268 77.8875 170.021 76.65 169.105 76.0402C168.19 75.4304 166.952 75.6792 166.342 76.5958C165.731 77.5125 165.979 78.75 166.894 79.3598Z"
      fill="#354156"
    />
    <path
      d="M191.069 103.147L184.094 105.298L189.649 113.514L185.122 116.575L179.567 108.359L174.972 114.031L171.003 90.8159L191.069 103.147Z"
      fill="#8E96AB"
    />
    <g filter="url(#filter3_d_5879_131700)">
      <path
        d="M52.8904 67.9505L70.5902 87.7356C71.1851 88.4202 71.0023 89.5239 70.217 90.2262L47.7994 110.275C47.0141 110.978 45.8848 110.992 45.317 110.339L22.9272 84.5725C22.3323 83.8879 22.5151 82.7842 23.3004 82.0819L39.5424 67.5557L52.8904 67.9505Z"
        fill="#5C6479"
      />
    </g>
    <path
      d="M38.7471 66.6953L43.8321 72.7015C44.5463 73.5451 45.86 73.5914 46.7036 72.8772L52.0349 68.3635"
      fill="#2E3746"
    />
    <g clip-path="url(#clip0_5879_131700)">
      <path
        d="M33.9063 71.3169L32.6099 72.4146L33.3644 73.3057L34.6608 72.2081L33.9063 71.3169Z"
        fill="#2E3746"
      />
      <path
        d="M35.9698 71.0996L34.6733 72.1973L35.4278 73.0884L36.7243 71.9908L35.9698 71.0996Z"
        fill="#2E3746"
      />
      <path
        d="M35.4049 73.0869L34.1084 74.1846L34.8629 75.0757L36.1593 73.9781L35.4049 73.0869Z"
        fill="#2E3746"
      />
      <path
        d="M37.4683 72.8697L36.1719 73.9673L36.9264 74.8585L38.2228 73.7608L37.4683 72.8697Z"
        fill="#2E3746"
      />
      <path
        d="M36.9136 74.8692L35.6172 75.9668L36.3717 76.858L37.6681 75.7603L36.9136 74.8692Z"
        fill="#2E3746"
      />
      <path
        d="M38.9771 74.6519L37.6807 75.7495L38.4352 76.6407L39.7316 75.543L38.9771 74.6519Z"
        fill="#2E3746"
      />
      <path
        d="M38.4122 76.6387L37.1157 77.7363L37.8702 78.6275L39.1667 77.5299L38.4122 76.6387Z"
        fill="#2E3746"
      />
      <path
        d="M40.4757 76.4219L39.1792 77.5195L39.9337 78.4107L41.2301 77.3131L40.4757 76.4219Z"
        fill="#2E3746"
      />
      <path
        d="M39.921 78.4209L38.6245 79.5186L39.379 80.4097L40.6755 79.3121L39.921 78.4209Z"
        fill="#2E3746"
      />
      <path
        d="M41.9844 78.2041L40.688 79.3018L41.4425 80.1929L42.7389 79.0953L41.9844 78.2041Z"
        fill="#2E3746"
      />
      <path
        d="M41.4195 80.1909L40.123 81.2886L40.8775 82.1797L42.174 81.0821L41.4195 80.1909Z"
        fill="#2E3746"
      />
      <path
        d="M43.483 79.9737L42.1865 81.0713L42.941 81.9625L44.2375 80.8648L43.483 79.9737Z"
        fill="#2E3746"
      />
      <path
        d="M42.9283 81.9732L41.6318 83.0708L42.3863 83.962L43.6828 82.8643L42.9283 81.9732Z"
        fill="#2E3746"
      />
      <path
        d="M44.981 81.7437L43.6846 82.8413L44.4391 83.7325L45.7355 82.6348L44.981 81.7437Z"
        fill="#2E3746"
      />
      <path
        d="M44.4268 83.7432L43.1304 84.8408L43.8849 85.732L45.1813 84.6344L44.4268 83.7432Z"
        fill="#2E3746"
      />
      <path
        d="M46.4903 83.5259L45.1938 84.6235L45.9483 85.5147L47.2448 84.4171L46.4903 83.5259Z"
        fill="#2E3746"
      />
      <path
        d="M44.6392 86.623L48.1672 90.7902L50.7727 88.5843L47.2447 84.4171L44.6392 86.623ZM50.0531 88.5255L48.228 90.0707L47.2078 88.8658L49.0329 87.3206L50.0531 88.5255Z"
        fill="#2E3746"
      />
      <path
        d="M50.5258 99.7781L50.4614 97.6347C50.4696 97.2615 50.4699 96.9811 50.4887 96.6204L50.478 96.6078L49.0557 97.812L48.3862 97.0213L51.0421 94.7727L51.5522 95.3752L51.6138 97.4133C51.6182 97.7759 51.6246 98.1152 51.5846 98.4508L51.5952 98.4633L53.156 97.1419L53.8361 97.9452L51.004 100.343L50.5258 99.7781Z"
        fill="#2E3746"
      />
      <path
        d="M52.1653 92.2705C52.3991 92.5466 52.3764 92.9537 52.0491 93.2308C51.7344 93.4972 51.3292 93.4524 51.0954 93.1763C50.8384 92.8982 50.8611 92.4912 51.1884 92.2141C51.5262 91.9496 51.9209 91.9818 52.1653 92.2705ZM54.6293 97.2738L51.8983 94.048L52.9052 93.1955L55.6363 96.4213L54.6293 97.2738Z"
        fill="#2E3746"
      />
      <path
        d="M54.6244 93.5929C54.2631 93.1662 53.9423 92.8128 53.6853 92.5348L54.5538 91.7995L54.9867 92.2087L54.9993 92.1981C54.9516 91.6567 55.1572 91.1594 55.6355 90.7544C56.3404 90.1577 57.503 90.2292 58.3744 91.2584C59.3733 92.4383 59.0982 93.6193 58.3682 94.2374C57.978 94.5677 57.5378 94.6603 57.2167 94.5874L57.2041 94.598L58.5643 96.2046L57.5574 97.0572L54.6244 93.5929ZM56.2796 93.506C56.3434 93.5813 56.4197 93.646 56.4854 93.6981C56.7821 93.921 57.1913 93.9193 57.4808 93.6742C57.9214 93.3012 57.8649 92.7241 57.3974 92.1718C56.9617 91.6572 56.4057 91.4599 55.9525 91.8436C55.663 92.0887 55.592 92.5152 55.7841 92.8697C55.814 92.9306 55.8545 93.004 55.9077 93.0667L56.2796 93.506Z"
        fill="#2E3746"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_5879_131700"
        x="59.0024"
        y="9.69922"
        width="87.7764"
        height="95.1035"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5879_131700"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5879_131700"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_5879_131700"
        x="116.62"
        y="50.8564"
        width="94.7554"
        height="94.2295"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5879_131700"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5879_131700"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_5879_131700"
        x="131.761"
        y="52.6333"
        width="84.3594"
        height="82.9961"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5879_131700"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5879_131700"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_5879_131700"
        x="0.575195"
        y="56.5557"
        width="92.3667"
        height="87.2603"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood
          flood-opacity="0"
          result="BackgroundImageFix"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="11" />
        <feGaussianBlur stdDeviation="11" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_5879_131700"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_5879_131700"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_5879_131700"
        x1="166.97"
        y1="60.1889"
        x2="161.062"
        y2="113.119"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#68728B" />
        <stop
          offset="0.9964"
          stop-color="#646E87"
        />
      </linearGradient>
      <linearGradient
        id="paint1_linear_5879_131700"
        x1="188.862"
        y1="60.6971"
        x2="159.339"
        y2="105.025"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#68728B" />
        <stop
          offset="0.9964"
          stop-color="#646E87"
        />
      </linearGradient>
      <clipPath id="clip0_5879_131700">
        <rect
          width="11.4951"
          height="34.0431"
          fill="white"
          transform="translate(29.5513 75.0039) rotate(-40.2525)"
        />
      </clipPath>
    </defs>
  </svg>
</template>

<style scoped>
svg {
  display: inline-block;
  vertical-align: middle;
}
</style>
